export const wordPool = {
  title: '단어 풀',
  subtitle: '레벨별 단어와 구문 확인',
  
  // Filters
  filterByLanguage: '언어로 필터',
  filterByLevel: '레벨로 필터',
  allLanguages: '모든 언어',
  allLevels: '모든 레벨',
  
  // Languages
  japanese: '日本語',
  korean: '한국어',
  english: 'English',
  
  // Levels
  levelA: '레벨 A',
  levelB: '레벨 B',
  levelC: '레벨 C',
  
  // Table Headers
  word: '단어/구문',
  meaning: '의미',
  language: '언어',
  level: '레벨',
  
  // Actions
  addWord: '단어 추가',
  search: '검색',
  searchPlaceholder: '단어 검색...',
  
  // Messages
  noWords: '단어를 찾을 수 없습니다',
  loading: '로딩 중...'
};
